import type { ReactNode } from 'react'
import { useRouteError } from 'react-router-dom'
import { ErrorState, Stack } from '../../core'
import { shouldSuppressStaleClientBundleError } from '../utils/vitePreloadErrorRecovery'

export interface StaleClientBundleErrorElementProps {
  fallback?: ReactNode
}

export function StaleClientBundleErrorElement({
  fallback,
}: StaleClientBundleErrorElementProps) {
  const error = useRouteError()

  if (error instanceof Error && shouldSuppressStaleClientBundleError(error)) {
    return null
  }

  if (fallback) {
    return fallback
  }

  return (
    <Stack align="center" grow="fill" justify="center">
      <ErrorState error={error} />
    </Stack>
  )
}
